<template>
  <v-data-table
    v-bind="dataTableAttrs"
    :headers="headersShown"
    :items="list"
    :loading="isLoading"
    :options.sync="options"
    :server-items-length="total"
    :items-per-page.sync="itemsPerPage"
    v-model="selectedItems"
    @update:items-per-page="handleItemsPerPageUpdated"
    :show-select="false"
  >
    <template v-slot:top>
      <rs-table-title-bar
        class="mt-6"
        v-if="$refs.headSearch"
        title=""
        icon=""
        @clear-filters="$refs.headSearch.reset"
        @reload="loadList"
        :search.sync="search.query"
        hide-edit
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:body.prepend="{ headers }">
      <rs-table-head-search
        :headers="headers"
        :search.sync="search"
        ref="headSearch"
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.last_used_at="{ value }">
      <rs-table-cell-date show-time :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.created_at="{ value }">
      <rs-table-cell-date show-time :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.expires_at="{ value }">
      <rs-table-cell-date show-time :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.is_mobile="{ value }">
      <rs-table-cell-boolean :value="value" />
    </template>
  </v-data-table>
</template>

<script>
import { debounce } from "@/core/plugins/debounce";
import { hasDataTable } from "@/view/mixins";

export default {
  name: "AdminTokenList",
  mixins: [hasDataTable],
  props: {
    userId: {
      type: Number,
      required: false,
    },
  },
  watch: {
    userId() {
      this.loadList();
    },
    search: {
      handler: debounce(function () {
        this.loadList();
      }),
      deep: true,
    },
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    },
  },
  data() {
    return {
      options: {
        sortBy: ["last_used_at"],
        sortDesc: [true],
      },
      headers: [
        {
          text: "Cihaz Adı",
          value: "name",
          searchable: "text",
        },
        {
          text: "Son Etkinlik",
          value: "last_used_at",
          searchable: "date",
        },
        {
          text: "Oluşturulma",
          value: "created_at",
          searchable: "date",
        },
        {
          text: "SKT",
          value: "expires_at",
          searchable: "date",
        },
        {
          text: "Mobil",
          value: "is_mobile",
          searchable: "yesNo",
          align: "center",
          width: "40px",
        },
      ],
    };
  },
  methods: {
    loadList() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.list = [];

      const params = Object.assign(
        this.buildSearchParams(this.search, this.options)
      );

      if (this.userId) {
        params.user_id = this.userId;
      }

      return this.$api
        .query("api-super-admin/tokens", {
          params,
        })
        .then((response) => {
          this.loadListFromResponse(response);
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => (this.isLoading = false));
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loadList();
    });
  },
};
</script>
